export function verifyIdIsUuid(id: string) {
  const uuidPattern = new RegExp(/^([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})$/, 'i')
  return uuidPattern.test(id)
}